/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SourceContactTag } from './SourceContactTag';
import {
    SourceContactTagFromJSON,
    SourceContactTagFromJSONTyped,
    SourceContactTagToJSON,
} from './SourceContactTag';

/**
 * 
 * @export
 * @interface BulkUpdateSourceContactTagsRequest
 */
export interface BulkUpdateSourceContactTagsRequest {
    /**
     * 
     * @type {Array<SourceContactTag>}
     * @memberof BulkUpdateSourceContactTagsRequest
     */
    tags: Array<SourceContactTag>;
}

/**
 * Check if a given object implements the BulkUpdateSourceContactTagsRequest interface.
 */
export function instanceOfBulkUpdateSourceContactTagsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "tags" in value;

    return isInstance;
}

export function BulkUpdateSourceContactTagsRequestFromJSON(json: any): BulkUpdateSourceContactTagsRequest {
    return BulkUpdateSourceContactTagsRequestFromJSONTyped(json, false);
}

export function BulkUpdateSourceContactTagsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateSourceContactTagsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tags': ((json['tags'] as Array<any>).map(SourceContactTagFromJSON)),
    };
}

export function BulkUpdateSourceContactTagsRequestToJSON(value?: BulkUpdateSourceContactTagsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tags': ((value.tags as Array<any>).map(SourceContactTagToJSON)),
    };
}

